import React, { memo, SVGAttributes } from 'react';

export const AddItemEmptyState = memo(function AddItemEmptyState(
  props: SVGAttributes<HTMLOrSVGElement>,
) {
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" {...props}>
      <path
        d="M86.048 8.821L49.156 22.191C47.1886 22.9039 45.585 24.3691 44.698 26.2644C43.8109 28.1596 43.7131 30.3296 44.426 32.297L44.644 32.899C45.3569 34.8664 46.8221 36.47 48.7174 37.357C50.6126 38.2441 52.7826 38.3419 54.75 37.629L91.642 24.259C93.6094 23.5461 95.213 22.0809 96.1 20.1856C96.987 18.2904 97.0849 16.1204 96.372 14.153L96.154 13.551C95.4411 11.5836 93.9758 9.98003 92.0806 9.09298C90.1854 8.20593 88.0154 8.1081 86.048 8.821Z"
        fill="#C2E2FF"
      />
      <path
        d="M95.4151 46.93L63.6291 40.912L57.6121 72.698L89.3971 78.715L95.4151 46.929V46.93Z"
        fill="#116DFF"
      />
      <path
        d="M85.34 60.98L77.03 59.4L78.59 51.16L77.61 50.98L76.05 59.22L67.88 57.67L67.7 58.65L75.86 60.2L74.3 68.44L75.29 68.63L76.85 60.39L85.16 61.96L85.34 60.98Z"
        fill="white"
      />
      <path
        d="M83.3 112.89C73.47 112.89 64.46 105.47 62.2 94.79L73.94 92.3C75.14 97.97 80.0399 101.75 84.8799 100.72C87.1099 100.25 89.03 98.8 90.29 96.65C91.66 94.3 92.08 91.44 91.47 88.59L103.21 86.1C104.43 91.87 103.53 97.77 100.66 102.69C97.68 107.81 92.96 111.28 87.37 112.46C86.01 112.75 84.6499 112.89 83.3099 112.89H83.3Z"
        fill="#FFB6AC"
      />
      <path
        d="M40 102C40 96.477 35.523 92 30 92C24.477 92 20 96.477 20 102C20 107.523 24.477 112 30 112C35.523 112 40 107.523 40 102Z"
        fill="#28BF9A"
      />
      <path
        d="M42.97 48.98C47.63 59.3 43.03 71.44 32.71 76.1C22.39 80.76 10.25 76.16 5.58997 65.84"
        fill="#FFD527"
      />
      <path
        d="M29.59 23.83L22.41 32.35L11.45 30.39L7.66003 19.92L14.84 11.4L25.8 13.36L29.59 23.83ZM111 31.5C111 28.46 108.54 26 105.5 26C102.46 26 100 28.46 100 31.5C100 34.54 102.46 37 105.5 37C108.54 37 111 34.54 111 31.5ZM115 59H100V60H115V59ZM105 65H98V66H105V65Z"
        fill="#192C55"
      />
    </svg>
  );
});
